module.exports = __webpack_public_path__ + "static/homepage_1-47440900f804f58615a68d7650e75b44.svg";